import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=6d751ce2&"
import script from "./LoginButton.vue?vue&type=script&lang=js&"
export * from "./LoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@0.28.11_lodash@4.17.21_webpack@3.12.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/reused-components/login-button/LoginButton.vue
// module id = 510
// module chunks = 58